<mat-nav-list>
    <div mat-subheader>{{ 'Notifications' | translate }}</div>
    <mat-divider></mat-divider>
    <mat-list-item *ngFor="let item of notificationData">
        <div class="left-img">
            <img [src]="item.img" alt="">
        </div>
        <div class="text">
            {{item.text}}
            <small>{{item.time}}</small>
        </div>
        <mat-icon>keyboard_arrow_right</mat-icon>
        <mat-divider></mat-divider>
    </mat-list-item>
</mat-nav-list>
<button class="bg-primary-15" mat-stroked-button color="primary">{{ 'View All Notifications' | translate }}</button>
